import script from "./VolumeWeight.vue?vue&type=script&setup=true&lang=js"
export * from "./VolumeWeight.vue?vue&type=script&setup=true&lang=js"

import "./VolumeWeight.vue?vue&type=style&index=0&id=6bb848ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb848ba"]])

export default __exports__